<div class="input-group quantity" style="flex-wrap: nowrap">
  <button class="input-group-text py-0 px-2" (click)="quantityDecrease()" [disabled]="disabled == true || quantity <= 0">-</button>

  <input
    #quantityInput
    class="form-control p-0 quantityInput text-center"
    type="number"
    [step]="min"
    min="0"
    [max]="max"
    [(ngModel)]="quantity"
    (change)="quantityChanged()"
    (keydown.enter)="onEnterPressed()"
    (focus)="onFocus()"
    [disabled]="disabled == true"
  />

  <button class="input-group-text py-0 px-2" (click)="quantityIncrease()" [disabled]="disabled == true">+</button>
</div>
